// A flat list of routes in alphabetical order. The enum values are also
// used as the menu item names in the UI. Not sure if that's a good idea or not
export enum RouteNameEnum {
  ADMIN_DOCUMENTS = 'admin.wonderschoolDocuments',
  AGING_REPORTS = 'Aging Reports',
  APPS = 'Apps',
  AREA_51 = 'Area 51',
  ATTENDANCE = 'Attendance',
  AUTH_ERROR = 'Auth Error',
  AUTH_RETURN = 'Auth Return',
  AUTH_TOKEN = 'Auth Token',
  BILLING_SETTINGS = 'Billing Settings',
  CALENDAR = 'Calendar',
  COMPARABLE_PROGRAMS = 'Comparable Programs',
  CONTACTS = 'familyAndContactsLabel',
  DEVICES = 'Devices',
  DOCUMENTS = 'Documents',
  ENROLLED_FAMILIES = 'Enrolled Families',
  ENROLLMENTS_ADMIN = 'Enrollments Admin',
  EVENTS = 'Events',
  OPEN_HOUSE_EVENTS = 'Open House & Events',
  SEARCH_SOCIAL_MARKETING = 'Search & Social Marketing',
  FLYERS = 'Flyers',
  GROUP_MESSAGE = 'Group Message',
  MARKETING_ANALYTICS = 'Analytics',
  AI_PHONE = 'AI Phone',
  // i18n key resolved via t() in LeftNavigation (see en/es translation.json).
  // Use an i18n key because routes are keyed by name in allRoutesMap
  // (navigationHooks), and duplicate display names would overwrite each other.
  SETTINGS = 'navigation.listingsAndWebsites.visibilitySettings',
  // i18n key, same convention as SETTINGS above.
  CREDENTIALS = 'navigation.schoolManagement.credentials',
  FOOD_PROGRAM_CLAIMS = 'food.claims.list',
  FOOD_PROGRAM_CLAIM_CREATE = 'food.claims.create',
  FOOD_PROGRAM_CLAIM_UPDATE = 'food.claims.update',
  FOOD_PROGRAM_MEALS = 'food.meals.list',
  FOOD_PROGRAM_MEAL_CREATE = 'food.meals.create',
  FOOD_PROGRAM_MEAL_UPDATE = 'food.meals.update',
  FOOD_PROGRAM_MEAL_RECORD_CREATE = 'food.meals.record.create',
  FOOD_PROGRAM_MENU_PLANNING = 'food.menu.planning',
  FOOD_PROGRAM_MENU_PLANNING_EDIT = 'food.menu.planning.edit',
  FOOD_PROGRAM_REPORTS = 'food.reports',
  FORMS_BUILDER = 'Forms Builder',
  HELP_CENTER = 'Help Center',
  TEACHER_RECRUITMENT = 'Teacher Recruitment',
  TEACHER_RECRUITMENT_FULL_TIME = 'Full Time Teachers',
  TEACHER_RECRUITMENT_SUBSTITUTE = 'Substitute Teachers',
  LICENSING_MANAGEMENT = 'Licensing Management',
  NM_LICENSING = 'Licensing',
  HOME = 'Home',
  ADD_FAMILIES = 'Add Families',
  ADD_TO_BILLING = 'Add To Billing',
  IMPERSONATE = 'Impersonate',
  INTERESTED_FAMILIES = 'Interested Families',
  INTERESTED_LIST = 'Interested List',
  INTERESTED_MESSAGES = 'Interested Messages',
  INVOICE_EDIT_CONFIRM = 'Invoice Edit Confirm',
  INVOICE_EDIT_DETAILS = 'Invoice Edit Details',
  INVOICE_EDIT_STUDENTS = 'Invoice Edit Students',
  INVOICES = 'All Invoices',
  LEARNING_BEYOND_PAPER = 'Learning Beyond Paper',
  KINDER_CONNECT = 'Kinder Connect',
  LOCATIONS = 'Location Details',
  LOCATION_EDIT = 'Location Edit',
  MARKETING = 'Marketing',
  MESSAGES = 'Prospective Families',
  MESSAGING = 'Messages',
  MIGRATION_REPORT = 'Migration Report',
  NETWORKS = 'Networks',
  ONBOARDING = 'Onboarding',
  OPEN_LEDGER = 'Open Ledger',
  PARENT_HANDBOOK = 'Parent Handbook',
  PLAN_DETAILS = 'Plan Details',
  PROFILE = 'Profile',
  FINANCIAL_SUMMARY = 'financialSummary.title',
  PROVIDERS = 'Providers',
  RECURRING_PLANS = 'Billing Plans',
  RECURRING_PLAN_EDIT_DETAILS = 'Recurring Plan Edit Details',
  ROOMS = 'Rooms',
  SHARED_DEVICES = 'Shared Devices',
  SHARED_LEADS = 'Shared Leads',
  STAFF = 'Staff',
  STAFF_DETAILS = 'Staff Details',
  STAFF_TIMESHEET = 'timecards.staffTimesheet',
  SETUP_ASSISTANT = 'Setup Assistant',
  STUDENT_ADD = 'Add Student',
  STUDENT_ADD_CHILD = 'Add Child',
  STUDENT_ENROLLMENT = 'Enrollment',
  STUDENT_ENROLLMENT_SUMMARY = 'Enrollment Summary',
  STUDENT_ENROLLMENT_INVOICE = 'Enrollment Invoice',
  STUDENT_DETAILS = 'Student Details',
  STUDENT_UNENROLL = 'End Enrollment',
  UNENROLLMENTS = 'unenrollments.dashboard.navLabel',
  STUDENTS = 'Students',
  STUDENTS_IMPORT = 'Import Students',
  STUDENTS_FILTER = 'Students Filter',
  SYSTEM_NOTIFICATIONS = 'System Notifications',
  TIME_SPACE_CALCULATOR = 'Time Space Percentage Calculator',
  TOURS = 'Tours',
  AVAILABILITY_SURVEY = 'Availability Survey',
  TOUR_REQUESTS = 'Tour Requests',
  TRANSACTIONS = 'Transactions',
  UPDATE_WEBSITE = 'Edit Program Listing',
  USERS = 'Users',
  VIEW_WEBSITE = 'View Program Listing',
  WELCOME = 'Welcome',
  ZZZ = 'ZZZ', //For testing route not found
  DEBUG_PAGE = 'Debug Page',
  BUSINESS_COACHING = 'Business Coaching',
  NEW_STUDENT_ADD = 'New Student Add',
  NEW_STUDENT_ADD_CHILD = 'New Student Add Child',
  WONDERCHOOL_APP = 'Enrolled Messages',
  WONDERSCHOOL_PHONE_NUMBER = 'Wonderschool Phone Number',
  BUSINESS_COACHING_SURVEY = 'Business Coaching Survey',
  CHECK_IN_CHECK_OUT = 'Check In Check Out',
  MEAL_LOGGING = 'Meal Logging',
  TUITION_SETTINGS = 'Tuition Settings',
  TUITION_GENERATOR = 'Tuition Generator',
  BILLING_SIGN_UP = 'Billing Sign Up',
  TUITION_PRICING_COACHING = 'Tuition Pricing Coaching',
  ANNUAL_TUITION_INCREASES = 'Annual Tuition Increases',
  TAXES = 'Taxes',
  TAX_FORMS = '1099-K Tax Forms',
  SUBSIDY_PREPAYMENT = 'Subsidy Prepayment',
  SUBSIDY_PREPAYMENT_NOVA = 'Fast Subsidy',
  LAUNCH_NOVA = 'Launch',
  TRI_SHARE = 'Tri-Share',
  DEBIT_CARD = 'Debit Card',
  EARN_INTEREST = 'Earn interest',
  INSURANCE = 'Insurance',
  PAYROLL = 'Payroll',
  WHITE_LABEL_WEBSITE = 'White Label Website',
  GOOGLE_MY_BUSINESS = 'Google My Business Manager',
  YELP = 'Yelp Manager',
}

// IMPORTANT: These names cannot change, as they are used as feature flags in the DB.
export enum FeatureFlagEnum {
  DASHBOARD = 'Dashboard',
  DOCUMENTS = 'Documents',
  FINANCES = 'Finances',
  HELP_CENTER = 'Help/Resource Hub',
  MARKETPLACE = 'My Website',
  REPORTS = 'Reports',
  SETTINGS = 'Settings',
  STAFF = 'Staff',
  STUDENTS = 'Students',
  APP_STORE = 'Application Store',
}

// Type for the routes array defined in routes.ts
export type RouteType = {
  name: RouteNameEnum;
  path: string;
  headlessPath?: string;
  permission?: string;
  featureFlag?: FeatureFlagEnum;
  component?: React.ComponentType<any>;
  shouldOpenInNewTab?: boolean;
  shouldHide?: () => boolean;
  isNew?: boolean;
};

export type RouteParamType = {
  name: string;
  value: string;
};

// Type for the useRoutes hook
export type UseRoutesReturnType = {
  allRoutes: RouteType[];
  allActiveRoutes: RouteType[];
  getActiveRoute: (routeToFind: RouteNameEnum) => RouteType | undefined;
  getActiveRouteByPath: (path: string) => RouteType | undefined;
  getActiveRoutes: (routesToFind: RouteNameEnum | RouteNameEnum[]) => RouteType[];
  getRoute: (routeToFind: RouteNameEnum) => RouteType | undefined;
  getRoutePath: (route: RouteType, params?: RouteParamType[]) => string;
  getRoutePathByName: (routeName: RouteNameEnum, params?: RouteParamType[]) => string | undefined;
  goBack: () => void;
  gotoRoute: (route: RouteType, params?: RouteParamType[]) => void;
  gotoRouteByName: (routeName: RouteNameEnum, params?: RouteParamType[]) => void;
  isRouteActive: (route: RouteType) => boolean;
};

// Type for the invoicePaths object returned by the usePaths hook
export type InvoicePathsType = {
  invoices: string;
  invoiceEditConfirm: string;
  invoiceEditDetails: string;
  invoiceEditStudents: string;
};

// Type for the invoicePlanPaths object returned by the usePaths hook
export type RecurringPlansPathsType = {
  recurringPlans: string;
  recurringPlanEditDetails: string;
};

// Type for the usePaths hook
export type UsePathsReturnType = {
  paths: any; // I don't know how to type a const object
  invoicePaths: InvoicePathsType;
  recurringPlansPaths: RecurringPlansPathsType;
};
